import { Saira, Roboto_Flex, Plus_Jakarta_Sans } from "next/font/google";
import localFont from 'next/font/local';


const saira = Saira({
    subsets: ['latin'],
    variable: '--font-saira',
    axes: ['wdth'],
    display: 'swap',
})

const robotoFlex = Roboto_Flex({
    subsets: ['latin'],
    style: ['normal'],
    axes: ['wdth'],
    variable: '--font-roboto-flex',
    weight: 'variable',
    display: 'swap',
})

const plusJakartaSans = Plus_Jakarta_Sans({
    subsets: ['latin'],
    style: ['normal'],
    variable: '--font-plus-jakarta-sans',
    display: 'swap',
})

const fontAwesome = localFont({
    src: [
        { path: '../fonts/FontAwesomeStarsOnly.woff2' },
        { path: '../fonts/FontAwesomeStarsOnly.ttf' }
    ],
    variable: '--font-font-awesome',
    display: 'swap',
})

export const fonts = {
    saira,
    robotoFlex,
    plusJakartaSans,
    fontAwesome,
}; 